import { useIssueCreateSidePanelContext } from '../providers/IssueCreateSidePanelContextProvider.tsx';

import { useIsAIIssueCreationAllowed } from './useIsAIIssueCreationAllowed.tsx';
import { getIsCreateIssueWithAiEnabledByUser } from './localStorageHelpers.ts';

export const useIsAIIssueCreationEnabled = () => {
	const [{ contentId }] = useIssueCreateSidePanelContext();
	const aiIssueCreationEnablement = useIsAIIssueCreationAllowed({ contentId });
	const isAiEnabled = aiIssueCreationEnablement?.isEnabled ?? false;
	const isCreateIssueWithAiEnabledByUser = getIsCreateIssueWithAiEnabledByUser();

	return isAiEnabled && isCreateIssueWithAiEnabledByUser;
};
